import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { Icon } from '../../icons';
import { variants } from './variants';
import { StyledButton, IconContainer, HoverIcon } from './styles.js';

export const LinkButton = forwardRef(
  (
    {
      children,
      href,
      target,
      horizontalPadding = 8,
      disabled,
      icon,
      onClick,
      verticalPadding = 4,
      percentWidthMobile,
      variant = 'primary',
      hoverIcon = null,
      minWidth = 0,
      fullWidth = false,
    },
    ref,
  ) => {
    return (
      <Link href={href} passHref>
        <StyledButton
          ref={ref}
          as="a"
          horizontalPadding={horizontalPadding}
          verticalPadding={verticalPadding}
          percentWidthMobile={percentWidthMobile}
          disabled={disabled}
          target={target}
          onClick={onClick}
          variant={variant}
          hasHoverIcon={!!hoverIcon}
          minWidth={minWidth}
          fullWidth={fullWidth}
          icon={icon?.position}
        >
          {icon?.position === 'before' && (
            <IconContainer position={icon.position}>
              <Icon {...icon} id="link_button_before" />
            </IconContainer>
          )}
          {children}
          {icon?.position === 'after' ||
            (icon?.position === 'end' && (
              <IconContainer position={icon.position}>
                <Icon {...icon} id="link_button_after" />
              </IconContainer>
            ))}
          {hoverIcon && (
            <HoverIcon>
              <Icon
                alt=""
                size="22px"
                iconName={hoverIcon}
                color={variants[variant].active.text}
                id="link_button_hover"
              />
            </HoverIcon>
          )}
        </StyledButton>
      </Link>
    );
  },
);

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  horizontalPadding: PropTypes.number,
  verticalPadding: PropTypes.number,
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.shape({
    position: PropTypes.oneOf(['before', 'after', 'end']),
  }),
  percentWidthMobile: PropTypes.number,
  hoverIcon: PropTypes.string,
  minWidth: PropTypes.number,
  fullWidth: PropTypes.bool,
  target: PropTypes.string,
  variant: PropTypes.oneOf(Object.keys(variants)),
};
